(() => {
  'use strict';

  const main = document.querySelector('main[data-template="product"]');
  if (!main) return;

  const formSelector = 'product-form form[data-type="add-to-cart-form"]';
  let syncFrame = 0;

  const getProductForm = () =>
    Array.from(main.querySelectorAll(formSelector)).find((form) => !form.closest('quick-add-modal')) || null;

  const getSourceButton = () => getProductForm()?.querySelector('.product-form__submit') || null;

  const sticky = document.createElement('aside');
  sticky.className = 'solea-sticky-atc';
  sticky.setAttribute('aria-label', 'Quick add to cart');
  sticky.innerHTML = `
    <button class="solea-sticky-atc__button" type="button">
      <span class="solea-sticky-atc__icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none" focusable="false">
          <path d="M7 8V6a5 5 0 0 1 10 0v2M5.5 8h13l1 13h-15l1-13Z" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </span>
      <span class="solea-sticky-atc__spinner" aria-hidden="true"></span>
      <span class="solea-sticky-atc__label">ADD TO CART</span>
    </button>`;

  const stickyButton = sticky.querySelector('.solea-sticky-atc__button');
  const stickyLabel = sticky.querySelector('.solea-sticky-atc__label');

  const sourceIsLoading = (button) =>
    button?.classList.contains('loading') || button?.getAttribute('aria-busy') === 'true';

  const sync = () => {
    syncFrame = 0;
    const form = getProductForm();
    const sourceButton = getSourceButton();
    const variantInput = form?.querySelector('input[name="id"]');
    const label = sourceButton?.querySelector('span')?.textContent?.trim();
    const disabled =
      !sourceButton ||
      sourceButton.disabled ||
      sourceButton.getAttribute('aria-disabled') === 'true' ||
      !variantInput ||
      variantInput.disabled;

    stickyButton.disabled = disabled;
    stickyButton.setAttribute('aria-disabled', String(disabled));
    stickyButton.classList.toggle('is-loading', sourceIsLoading(sourceButton));
    stickyLabel.textContent = label || window.variantStrings?.addToCart || 'ADD TO CART';
  };

  const scheduleSync = () => {
    if (syncFrame) return;
    syncFrame = window.requestAnimationFrame(sync);
  };

  stickyButton.addEventListener('click', () => {
    const sourceButton = getSourceButton();
    if (!sourceButton || sourceButton.disabled || sourceButton.getAttribute('aria-disabled') === 'true') {
      scheduleSync();
      return;
    }

    sourceButton.click();
    scheduleSync();
  });

  main.addEventListener('change', scheduleSync);
  main.addEventListener('input', scheduleSync);

  const productInfo = main.querySelector('product-info') || main;
  new MutationObserver(scheduleSync).observe(productInfo, {
    attributes: true,
    childList: true,
    characterData: true,
    subtree: true,
    attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'class', 'value'],
  });

  const cartDrawer = document.querySelector('cart-drawer');
  if (cartDrawer) {
    const syncDrawerState = () => {
      document.body.classList.toggle('solea-cart-drawer-open', cartDrawer.classList.contains('active'));
    };

    new MutationObserver(syncDrawerState).observe(cartDrawer, {
      attributes: true,
      attributeFilter: ['class'],
    });
    syncDrawerState();
  }

  document.body.appendChild(sticky);
  document.body.classList.add('solea-has-sticky-atc');
  sync();
})();
